const main = () => {
    if (document.querySelector('.c-others-select-search') == null) return;

    // サイトモード切替
    document.querySelectorAll('.c-others-select-search').forEach((obj) => {
        obj.querySelector('form select[name="key"]').addEventListener('change', (e) => {
            const formObj = e.currentTarget.closest('form');
            formObj.submit();
        });
    });
}

export default main;